export const getLatLngCenter = locations => {
  const rad2degr = rad => rad * 180 / Math.PI;
  const degr2rad = degr => degr * Math.PI / 180;
  let sumX = 0;
  let sumY = 0;
  let sumZ = 0;

  locations.forEach(loc => {
    const { latitude, longitude } = loc.location;
    const lat = degr2rad(latitude);
    const lng = degr2rad(longitude);
    sumX += Math.cos(lat) * Math.cos(lng);
    sumY += Math.cos(lat) * Math.sin(lng);
    sumZ += Math.sin(lat);
  });

  const avgX = sumX / locations.length;
  const avgY = sumY / locations.length;
  const avgZ = sumZ / locations.length;

  const lng = Math.atan2(avgY, avgX);
  const hyp = Math.sqrt(avgX * avgX + avgY * avgY);
  const lat = Math.atan2(avgZ, hyp);

  return `${rad2degr(lat)},${rad2degr(lng)}`;
};

export const markerCluster = (crimes, zoom) => {
  let cluster;
  zoom = zoom || 14;
  if (zoom && !cluster) {
    cluster = zoom ? Math.floor(7 / 100 * (zoom / 19 * 100)) : 8;
  }

  const sortedCrimes = crimes.reduce((prev, crime, index) => {
    const { latitude, longitude } = crime.location;
    const label = `${latitude.substr(0, cluster)},${longitude.substr(
      0,
      cluster
    )}`;
    if (prev[label]) {
      prev[label].push(crime);
    } else {
      prev[label] = [crime];
    }
    return prev;
  }, {});
  const positionCluster = Object.keys(sortedCrimes).reduce((prev, cluster) => {
    const position = getLatLngCenter(sortedCrimes[cluster]);
    prev[position] = sortedCrimes[cluster];
    return prev;
  }, {});

  return positionCluster;
};



// WEBPACK FOOTER //
// ./src/helpers/markerCluster.js